import React, {useContext, createContext, useMemo} from 'react';

import useLoadGsiScript from './useLoadGsiScript';

const GoogleOAuthContext = createContext();

export const useGoogleOAuth = () => {
    const context = useContext(GoogleOAuthContext);
    if (!context) {
        throw new Error(
            'Google OAuth components must be used within GoogleOAuthProvider',
        );
    }
    return context;
}

const GoogleOAuthProvider = (props) => {
    const {
        clientId,
        onScriptLoadSuccess=f=>f,
        onScriptLoadError=f=>f,
        children
    } = props;

    const scriptState = useLoadGsiScript({
        onScriptLoadSuccess,
        onScriptLoadError,
    });

    const contextValue = useMemo(
        () => ({
            clientId,
            scriptLoadedSuccessfully: scriptState.scriptLoadedSuccessfully,
            isLoadingScript: scriptState.isLoading,
        }),
        [clientId, scriptState.scriptLoadedSuccessfully, scriptState.isLoading],
    );

    return (
        <GoogleOAuthContext.Provider value={contextValue}>
            {children}
        </GoogleOAuthContext.Provider>
    );
}

export default GoogleOAuthProvider;


